import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Material UI
import { makeStyles } from '@material-ui/core/styles';
import MuiCollapse from '@material-ui/core/Collapse';
import MuiListItem from '@material-ui/core/ListItem';
import MuiListItemIcon from '@material-ui/core/ListItemIcon';
import MuiListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import MuiListItemText from '@material-ui/core/ListItemText';
import MuiSwitch from '@material-ui/core/Switch';
// Custom
import AppIcon from 'components/icons/AppIcon';
// Internal
import { getInternalLink } from './internal/Tools';

const useStyles = (level) => makeStyles((theme) => {
  if (level) {
    return {
      nested: {
        paddingLeft: theme.spacing((level + 1) * 2),
      },
    };
  }
  return null;
});

const ListItem = ({
  button, path, level, primaryText, secondaryText, selection, leftItem, rightItem,
  nestedItems, initiallyOpen, selected, disableGutters, divider, onClick,
}) => {
  const classes = useStyles(level)();

  // Manage open status
  const [open, setOpen] = React.useState(initiallyOpen);
  const handleCollapse = () => {
    setOpen(!open);
  };

  // Nested items indicator
  const hasNestedItems = !_isEmpty(nestedItems);

  // Components props
  let listItemProps = {
    button, className: classes.nested, selected, disableGutters, divider,
  };
  listItemProps = {
    ...listItemProps,
    onClick: hasNestedItems ? handleCollapse : onClick,
  };
  const listItemTextProps = { primary: primaryText, secondary: secondaryText };

  return (
    <React.Fragment>
      <MuiListItem {...listItemProps} component={path ? getInternalLink(path) : 'div'}>
        {leftItem && (
          <MuiListItemIcon>
            {leftItem}
          </MuiListItemIcon>
        )}
        <MuiListItemText {...listItemTextProps} />
        {selection && (
          <MuiListItemSecondaryAction>
            <MuiSwitch
              edge="end"
              color="primary"
              onChange={(e) => selection.onSelect(e.target.checked)}
              checked={selection.selected}
            />
          </MuiListItemSecondaryAction>
        )}
        {!selection && rightItem && (
          <MuiListItemSecondaryAction>
            {rightItem}
          </MuiListItemSecondaryAction>
        )}
        {!selection && !rightItem && hasNestedItems && (
          <AppIcon id={open ? 'btnChevronUp' : 'btnChevronDown'} />
        )}
      </MuiListItem>
      {hasNestedItems && (
        <MuiCollapse in={open}>
          {nestedItems}
        </MuiCollapse>
      )}
    </React.Fragment>
  );
};

ListItem.propTypes = {
  button: PropTypes.bool,
  path: PropTypes.string,
  level: PropTypes.number,
  primaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  selection: PropTypes.shape({
    selected: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
  }),
  leftItem: PropTypes.element,
  rightItem: PropTypes.element,
  nestedItems: PropTypes.arrayOf(PropTypes.element),
  initiallyOpen: PropTypes.bool,
  selected: PropTypes.bool,
  disableGutters: PropTypes.bool,
  divider: PropTypes.bool,
  onClick: PropTypes.func,
};

ListItem.defaultProps = {
  button: true,
  path: null,
  level: null,
  secondaryText: null,
  selection: null,
  leftItem: null,
  rightItem: null,
  nestedItems: null,
  initiallyOpen: false,
  selected: false,
  disableGutters: false,
  divider: false,
  onClick: null,
};

export default React.memo(ListItem);



// WEBPACK FOOTER //
// ./components/core/ListItem.js